import { render } from "./OmbudsmanView.vue?vue&type=template&id=7ff8f310"
import script from "./OmbudsmanView.vue?vue&type=script&lang=js"
export * from "./OmbudsmanView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__